import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { auth } from "../firebase/firebaseConfig";
import { signOut } from "firebase/auth";

const PendingListingGuestRoute = () => {
    useEffect(() => {
        signOut(auth);
    }, []);
    return <Outlet />;
};

const GuestRoute = () => {
    const { currentUser, userLoading } = useAuth();

    if (userLoading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
                <div className="animate-spin h-14 w-14 border-4 border-black border-t-transparent rounded-full"></div>
            </div>
        );
    }

    const isBusiness = ["printShop", "supplier", "specialist"].includes(currentUser?.type);
    const listingIsNotApproved = isBusiness && currentUser?.status !== "approved";

    // A pending/rejected listing must remain on the login screen and must not
    // inherit a Firebase Auth session from a failed login attempt.
    if (listingIsNotApproved) {
        return <PendingListingGuestRoute />;
    }

    // If logged in → redirect away from login page
    if (currentUser) {
        if (currentUser.type === "printShop") {
            return <Navigate to="/shop/dashboard" replace />;
        } else if (currentUser.type === "supplier" || currentUser.type === "specialist") {
            return <Navigate to="/supplier/dashboard" replace />;
        }
    }

    // Not logged in → allow access to login page
    return <Outlet />;
};

export default GuestRoute;
